<template>
  <div class="row">
    <div class="col-12 padd-0">
      <div v-if="chatmessages.length > 0">
        <div class="row" style="min-height: 35px;">
          <div class="col-3"></div>
          <div class="col-7" style="text-align: right">
            <div style="display: inline; font-size: 18px; ">
              Scroll to:
              <b-form-select
                style="max-width: 30%"
                size="sm"
                v-model="DateIndexID"
                :options="prevMsgSendDateDATA"
                @change="historyScrollProcess()"
              ></b-form-select>
            </div>
          </div>
          <div class="col-2" style="text-align: left">
            <div class="bottomScrollClassButton" style="display: inline">
              <!-- :pressed.sync="scrollToBottom" -->
              <b-button
                @click="scrollToBottom == !scrollToBottom; !scrollToBottom ? DateIndexID = 0 : DateIndexID = chatmessages.length - 1; historyScrollProcess()"
                variant="outline-primary"
                size="sm"
              >{{scrollToBottom == false ? 'Scroll to top' : 'Scroll to bottom' }}</b-button>
            </div>
          </div>
        </div>
        <!--  -->
        <div
          :id="'historyContents-' + colId"
          class="historyChatView style-3"
          @scroll="detectScroll"
        >
          <ChatWindow :msgs="chatmessages" :prevMsgSendDate="prevMsgSendDate" :isMain="false" />
        </div>
      </div>
      <div v-else-if="loading == true">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div>
      <div v-else class="noMessagesFoundClass">It seems no messages were found in database</div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import $ from "jquery";
import ChatWindow from "./ChatWindow.vue";

export default {
  name: "viewChatWindow",
  components: {
    ChatWindow
  },
  props: {
    ssId: String,
    colId: String,
    mode: String,
    userId: String
  },
  data() {
    return {
      prevMsgSendDate: [],
      prevMsgSendDateDATA: [],
      chatmessages: [],
      DateIndexID: "",
      loading: false,
      scrollToBottom: false
    };
  },

  mounted() {
    this.chatmessages = [];
    if (this.mode == "userId") {
      this.loadMsgsByUserId();
    } else {
      this.loadMsgsBySsId();
    }
  },

  watch: {},

  methods: {
    setScrollToBottom: function(v) {
      this.scrollToBottom = v;
    },
    loadMsgsByUserId() {
      this.chatmessages = [];
      this.loading = true;
      let that = this;
      if (this.userId == "") {
        this.loading = false;
        return;
      }

      firebase
        .firestore()
        .collection(`archive`)
        .where("chatroom.userId", "==", this.userId) // sessChatId this.userId
        .get()
        .then(querySnapshot => {
          if (!querySnapshot.empty) {
            let chats = [];
            querySnapshot.forEach(doc => {
              chats.push(doc.data());
            });

            chats.sort((a, b) =>
              Date.parse(a.chatroom.dateRoomCreate) >
              Date.parse(b.chatroom.dateRoomCreate)
                ? 1
                : Date.parse(a.chatroom.dateRoomCreate) <
                  Date.parse(b.chatroom.dateRoomCreate)
                ? -1
                : 0
            );

            for (let i in chats) {
              let archiveMessages = chats[i].messages;
              that.FormHistoryMsgFromFt(archiveMessages);
            }

            that.chatHistoryLoading();
          }
          that.loading = false;
        })
        .catch(err => {
          console.log("Error getting document", err);
          that.loading = false;
          that.chatmessages = [];
          return;
        });
    },

    loadMsgsBySsId() {
      this.chatmessages = [];
      this.loading = true;
      let that = this;
      firebase
        .database()
        .ref("messages")
        .orderByChild("ssId")
        .equalTo(this.ssId)
        .once("value", function(snapshot) {
          if (snapshot.exists()) {
            snapshot.forEach(function(childSnapshot) {
              var childData = childSnapshot.val();
              childData.sendDate = that.timeZoneConvertor(childData.sendDate);
              that.chatmessages.push(childData);
            });

            that.chatHistoryLoading();
            that.loading = false;
          } else {
            firebase
              .firestore()
              .doc(`archive/${that.ssId}`) // sessChatId
              .get()
              .then(doc => {
                if (!doc.exists) {
                  that.chatmessages = [];
                } else {
                  let archiveMessages = doc.data().messages;

                  that.FormHistoryMsgFromFt(archiveMessages);

                  that.chatHistoryLoading();
                }
                that.loading = false;
              })
              .catch(err => {
                console.log("Error getting document", err);
                that.loading = false;
                that.chatmessages = [];
                return;
              });
          }
        });
    },

    FormHistoryMsgFromFt(archiveMessages) {
      for (let i = 0; i < archiveMessages.length; i++) {
        let messages = {
          data: {}
        };
        messages["author_type"] = archiveMessages[i].received_from;
        messages["sendDate"] = new Date(archiveMessages[i].send_date);
        messages["data"]["text"] = archiveMessages[i].text;
        if (
          archiveMessages[i].suggestions != undefined &&
          archiveMessages[i].suggestions != null &&
          archiveMessages[i].suggestions.length > 0
        ) {
          messages["data"]["suggestions"] = archiveMessages[i].suggestions;
        }
        this.chatmessages.push(messages);
      }
    },

    chatHistoryLoading() {
      this.prevMsgProcess();
      this.DateIndexID = this.chatmessages.length - 1;

      setTimeout(() => {
        this.historyScrollProcess();
      }, 300);
    },

    historyScrollProcess() {
      let sctollid = "#hDate" + this.DateIndexID;

      if ($(sctollid).offset() != undefined) {
        $(`#historyContents-${this.colId}`).animate(
          { scrollTop: $(sctollid).offset().top - 200 },
          1000
        );
      }
    },

    detectScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        this.scrollToBottom = false;
      } else if (scrollTop == 0) {
        this.scrollToBottom = true;
      }
    },

    prevMsgProcess() {
      this.prevMsgSendDate = [];
      this.prevMsgSendDateDATA = [];
      for (let j = 0; j < this.chatmessages.length; j++) {
        if (
          j == 0 ||
          this.chatmessages[j].sendDate.getDate() !=
            this.chatmessages[j - 1].sendDate.getDate()
        ) {
          this.prevMsgSendDate.push(j);
          this.prevMsgSendDateDATA.push({
            value: j,
            text:
              this.chatmessages[j].sendDate.toString().split(" ")[0] +
              " " +
              this.chatmessages[j].sendDate.toString().split(" ")[1] +
              " " +
              this.chatmessages[j].sendDate.toString().split(" ")[2] +
              " " +
              this.chatmessages[j].sendDate.toString().split(" ")[3]
          });
        }
      }

      this.DateIndexID = this.prevMsgSendDateDATA[0].value;
    },

    timeZoneConvertor(gotDate) {
      let gotDateTemp = new Date(gotDate);
      let newDateString =
        gotDateTemp.getUTCFullYear() +
        "-" +
        this.addZero4(gotDateTemp.getUTCMonth() + 1) +
        "-" +
        this.addZero4(gotDateTemp.getUTCDate()) +
        "T" +
        this.addZero4(gotDateTemp.getUTCHours()) +
        ":" +
        this.addZero4(gotDateTemp.getUTCMinutes()) +
        ":" +
        this.addZero4(gotDateTemp.getUTCSeconds()) +
        "-00:00";
      let formattedDate = new Date(newDateString);
      return formattedDate;
    },

    addZero4(s) {
      if (s.toString().length == 1) {
        s = "0" + s;
      }
      return s;
    }
  }
};
</script>
<style scoped>
.padd-0 {
  padding: 0;
}
.m-color {
  color: #266db3;
}
.bottomScrollClassButton {
  padding-bottom: 15px;
  text-align: right;
}
#style-3::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

#style-3::-webkit-scrollbar {
  width: 6px;
  background-color: #f5f5f5;
}

#style-3::-webkit-scrollbar-thumb {
  background-color: rgba(211, 56, 0, 0.808);
}

.style-3::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.style-3::-webkit-scrollbar {
  width: 6px;
  background-color: #f5f5f5;
}

.style-3::-webkit-scrollbar-thumb {
  background-color: rgba(211, 56, 0, 0.808);
}

.noMessagesFoundClass {
  min-height: 300px;
  line-height: 300px;
  font-size: 32px;
}
.historyChatView {
  min-height: 340px;
  height: 60vh;
  display: flex;
  overflow-y: scroll;
}
</style>




